import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ScriptsService } from '../shared/service/scripts.service';

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss'],
})
export class CabecalhoComponent implements OnInit {
  constructor(private scriptService: ScriptsService) {
    this.scriptService.load('barraGov');
  }

  @Output() altoContraste = new EventEmitter<any>();
  @Input() contraste: boolean;

  ngOnInit(): void { }

  onAltoContraste() {
    this.contraste = !this.contraste;
    this.altoContraste.emit(this.contraste);
  }
}
